import React, { useContext, useEffect } from "react";
import { NewsContext } from "../Contexts/NewsProvider";
import { NewsUI, NewsUIFeatured } from "../models/UIModels/News.ui";
import DropDownFilter from "../FilterComponents/DropDownFilter";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { ScrollTop } from "primereact/scrolltop";
import { hashScroll } from "../../UI/scripts/utils/hash-scroll";

const NewsApp: React.FC = () => {
  // News context context
  const {
    featuredNews,
    loading,
    newsToDisplay,
    filteredNews,
    selectedThemes,
    themeTypes,
    formatTypes,
    setSelectedThemes,
    selectedFormats,
    setSelectedFormats,
    takeAmount,
    setTakeAmount,
    setSelectedDates,
    selectedDates,
    filtersInUse,
  } = useContext(NewsContext);

  // Handle hash scrolling when content is loaded
  useEffect(() => {
    if (!loading && newsToDisplay.length > 0) {
      hashScroll.scrollToHash();
    }
  }, [loading, newsToDisplay]);

  useEffect(() => {}, [featuredNews]);

  const reset = () => {
    // Reset the filter
    setSelectedThemes([]);
    setSelectedFormats([]);
    setSelectedDates([]);
    setTakeAmount(12);
  };
  const resetDates = () => {
    setSelectedDates([]);
  };
  const datePickerClick = (value: any) => {
    // Handle date picker click
    if (value !== null && value[0] !== undefined) {
      setSelectedDates(value);
    }
  };

  const onThemeChange = (selectedOptions: any) => {
    // Handle theme change
    setSelectedThemes(selectedOptions);
  };
  const onFormatChange = (selectedOptions: any) => {
    // Handle format change
    setSelectedFormats(selectedOptions);
  };

  const skeleton = (amount: number) => {
    // return 12 skeleton items
    return Array.from({ length: amount }).map((_, index) => (
      <div key={index} className="col-md-4">
        <Skeleton width="100%" height="400px" />
      </div>
    ));
  };

  return (
    <>
      <header style={{ display: "none" }}>
        <h1 className="overview">Aktuelt</h1>
        <p>Her finder du de seneste nyheder fra COPI</p>
      </header>
      <div className="row">
        <div className="col-md-8 primary-featured wcag" id="item-1">
          {featuredNews[0] && featuredNews.length != 0 ? (
            <NewsUIFeatured
              title={featuredNews[0].title}
              containerId={"item-1"}
              iID={featuredNews[0].iID}
              link={featuredNews[0].link}
              pictures={featuredNews[0].pictures}
              publishedDate={featuredNews[0].publishedDate}
            />
          ) : (
            <Skeleton width="830px" height="540px" />
          )}
        </div>
        <div className="col-md-4 row ps-md-5 pe-0 mt-4 mt-md-0">
          <div className="col-md-12 pe-0 wcag mb-sm-4 mb-4" id="item-2">
            {featuredNews[1] ? (
              <NewsUIFeatured
                title={featuredNews[1].title}
                containerId={"item-2"}
                iID={featuredNews[1].iID}
                link={featuredNews[1].link}
                pictures={featuredNews[1].pictures}
                publishedDate={featuredNews[1].publishedDate}
              />
            ) : (
              <Skeleton width="348px" height="251px" />
            )}
          </div>
          <div className="col-md-12 mt-auto pe-0 wcag" id="item-3">
            {featuredNews[2] ? (
              <NewsUIFeatured
                title={featuredNews[2].title}
                containerId={"item-3"}
                iID={featuredNews[2].iID}
                link={featuredNews[2].link}
                pictures={featuredNews[2].pictures}
                publishedDate={featuredNews[2].publishedDate}
              />
            ) : (
              <Skeleton width="348px" height="251px" />
            )}
          </div>
        </div>
      </div>

      <h2 id="article-overview__header" className="overview article-overview__header">Flere nyheder</h2>

      <div
        className="container-fluid row article-overview__filters"
        id="selectorContainer"
      >
        <div className="col-md-12 mx-0 px-0">
          <div className="filters d-flex w-100 column-gap-3 flex-column flex-lg-row flex-md-column d-flex">
            {formatTypes.length > 0 && (
              <div className="filter my-3">
                <DropDownFilter
                  dropdownTitle="Vælg format"
                  filterOptions={formatTypes}
                  id="formatFilter"
                  onChange={onFormatChange}
                  selectedOptions={selectedFormats}
                />
              </div>
            )}
            {themeTypes.length > 0 && (
              <div className="filter my-3">
                <DropDownFilter
                  dropdownTitle="Vælg tema"
                  filterOptions={themeTypes}
                  id="themeFilter"
                  onChange={onThemeChange}
                  selectedOptions={selectedThemes}
                />
              </div>
            )}
           
            <div className="filter my-3">
              <Calendar
                onClearButtonClick={() => resetDates()}
                onTodayButtonClick={(e) => datePickerClick(e)}
                locale="da"
                showButtonBar
                value={selectedDates}
                dateFormat={"dd.mm.yy"}
                placeholder="Filtrer på dato"
                onChange={(e) => datePickerClick(e.value)}
                selectionMode="range"
                readOnlyInput
                hideOnRangeSelection
              />
            </div>
            <div className="filter my-3 d-flex justify-content-center">
              <Button
                disabled={!filtersInUse}
                className="btn btn-primary mx-auto d-flex mt-1"
                onClick={reset}
              >
                Nulstil filtre
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="row" id="results">
        {loading
          ? skeleton(newsToDisplay.length > 0 ? newsToDisplay.length : 12)
          : newsToDisplay.map((article, index) => (
              <NewsUI
                title={article.title}
                teaser={article.teaser}
                iID={article.iID}
                link={article.link}
                pictures={article.pictures}
                publishedDate={article.publishedDate}
                key={index}
              />
            ))}
      </div>
      <ScrollTop />
      {filteredNews?.length > takeAmount && (
        <Button
          className="btn btn-primary mx-auto d-flex mt-5 loadmore"
          onClick={() => setTakeAmount(takeAmount + 12)}
        >
          Indlæs flere
        </Button>
      )}
    </>
  );
};
export default NewsApp;
